export default __webpack_public_path__ + "static/media/Group 614.fdfcf161.png";